// extracted by mini-css-extract-plugin
export default {"bottom_affix":"index_bottom_affix_iCN0K","backToTop":"index_backToTop_osW5T"};